import { render } from "./RoomTable.vue?vue&type=template&id=1303f4b7&scoped=true"
import script from "./RoomTable.vue?vue&type=script&lang=js"
export * from "./RoomTable.vue?vue&type=script&lang=js"

import "./RoomTable.vue?vue&type=style&index=0&id=1303f4b7&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1303f4b7"]])

export default __exports__